import { memo } from "react";

import { PlainWidgetDecoration } from "@/lib/gql/__generated__/graphql";

/**
 * Snack ウィジェットカード（プレビュー用）
 *
 * ゲスト側 app/frontend/guest/plain/src/components/top/snack-widgets/SnackWidgetCard.astro の逐語再現。
 * レイアウト: aspect 3:2 の画像（下にタイトル）。
 * 装飾: Fill = offset colored rect が背面、Line = offset colored border が前面、Dot/None = なし。
 */

type Props = {
	thumbnail: string;
	title: string;
	primaryColor: string;
	widgetDecoration: PlainWidgetDecoration;
	fontFamily?: string;
	fontColor?: string;
};

export const WidgetItem = memo(({ thumbnail, title, primaryColor, widgetDecoration, fontFamily, fontColor }: Props) => {
	const isFill = widgetDecoration === PlainWidgetDecoration.Fill;
	const isLine = widgetDecoration === PlainWidgetDecoration.Line;

	return (
		<div className="featured-card-link block w-full">
			<div className="relative mb-4" style={{ aspectRatio: "3 / 2" }}>
				{isFill && (
					<div
						className="absolute left-2 top-2 z-0 size-full rounded"
						style={{ backgroundColor: primaryColor }}
					/>
				)}
				<div className="relative z-10 size-full overflow-hidden rounded-lg">
					{thumbnail ? (
						<img
							src={thumbnail}
							alt={title}
							loading="lazy"
							className="featured-card-media size-full object-cover"
						/>
					) : (
						<div className="size-full bg-zinc-100" />
					)}
				</div>
				{isLine && (
					<div
						className="pointer-events-none absolute left-2 top-2 z-20 size-full rounded border-2"
						style={{ borderColor: primaryColor }}
					/>
				)}
			</div>
			<p className="pb-2 text-sm font-medium text-zinc-900" style={{ fontFamily, color: fontColor }}>
				{title}
			</p>
		</div>
	);
});

WidgetItem.displayName = "WidgetItem";
